import React, { Component } from 'react';

import { Line } from 'react-chartjs-2';

import Moment from 'moment';
import classes from './Steering.css';

export default class SteeringEvents extends Component {
  state = {
    tZOffset: 0,
    dateTimeFormat: 'MMM D, h:mm a',
    hoursFormat: 'h:mm a',
    daysFormat: 'd',
  };
  componentDidMount() {
    var d = new Date();
    var n = d.getTimezoneOffset();
    var nowDateTime = d;
    var dateTime24 = new Date(Date.now() - (86400000 + 1200000));
    var dateTime7 = new Date(Date.now() - (7 * 86400000 + 1200000));
    this.setState({
      tZOffset: n,
      nowDateTime: nowDateTime,
      dateTime24: dateTime24,
      dateTime7: dateTime7,
    });
  }

  componentWillUpdate() {}
  componentDidUpdate() {}

  prepareXaxesOption() {
    let option = {
      type: 'time',
      time: {
        displayFormats: {
          hour: 'ha',
          day: 'MMM-D',
        },
      },
    };
    if (this.props.days === '1') {
      option.time.unit = 'hour';
      option.time.stepSize = 2;
    } else {
      option.time.unit = 'day';
      option.time.stepSize = 1;
    }
    return option;
  }

  prepareEvents(events, key) {
    return events.map((e) => {
      const value = e[key] === 0 ? null : e[key];
      return { x: Moment.utc(new Date(e.timestamp)), y: value };
    });
  }

  render() {
    let startDate =
      this.props.days === '1' ? this.state.dateTime24 : this.state.dateTime7;
    let endDate = this.state.nowDateTime;
    let xAxesOption = this.prepareXaxesOption();
    var today = new Date();
    var weekAgo = today - 1000 * 60 * 60 * 24 * 7;
    // console.log('events:::', this.props.events)
    if (
      this.props.events === undefined ||
      this.props.events.length === 0 ||
      this.props.noEvents === true
    ) {
      return (
        <div className={[classes.BodyRow, classes.BodyRow1].join(' ')}>
          <div className={classes.BodyTitle}>
            <b>{this.props.name}</b>
          </div>

          <div
            className={classes.BodyInfo}
            style={{ paddingTop: '18px', textAlign: 'center' }}
          >
            No available data can be found at this time.
          </div>
        </div>
      );
    }
    this.props.events.sort((e1, e2) => {
      if (e1.timestamp > e2.timestamp) {
        return 1;
      } else if (e1.timestamp < e2.timestamp) {
        return -1;
      } else {
        return 0;
      }
    });

    const successEvents = this.prepareEvents(this.props.events, 'bs_succeeded');
    const failedEvents = this.prepareEvents(this.props.events, 'bs_failed');
    // console.log("startDate", startDate, "endDate", endDate);
    var bandData = {
      datasets: [
        {
          label: this.props.name + ' Successes',
          fill: false,
          lineTension: 0.3,
          borderColor: 'rgba(255,255,255,0)',
          backgroundColor: 'rgba(255,255,255,0)',
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: 'miter',
          pointBorderColor: 'green',
          pointBackgroundColor: 'green',
          pointBorderWidth: 3,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: 'green',
          pointHoverBorderColor: 'green',
          pointHoverBorderWidth: 3,
          pointRadius: 1,
          pointHitRadius: 10,
          data: successEvents,
        },
        {
          label: this.props.name + ' Failure',
          fill: false,
          borderColor: 'rgba(255,255,255,0)',
          backgroundColor: 'rgba(255,255,255,0)',
          lineTension: 0.1,
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: 'miter',
          pointBorderColor: 'red',
          pointBackgroundColor: 'red',
          pointBorderWidth: 3,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: 'red',
          pointHoverBorderColor: 'red',
          pointHoverBorderWidth: 3,
          pointRadius: 1,
          pointHitRadius: 10,
          data: failedEvents,
        },
        //Below dataset is used to represent the start & end time of steering events.
        {
          fill: false,
          borderColor: 'rgba(255,255,255,0)',
          backgroundColor: '#fff',
          lineTension: 0.1,
          pointBorderWidth: 0,
          pointHoverRadius: 0,
          pointHoverBorderWidth: 0,
          pointRadius: 0,
          pointHitRadius: 0,
          data: [
            { x: Moment.utc(endDate), y: 0 },
            { y: 0, x: Moment.utc(startDate) },
          ],
        },
      ],
    };

    if (this.props.name.includes('Client')) {
      const troubledEvents = this.prepareEvents(
        this.props.events,
        'bs_troubled'
      );
      // console.log("troubledEvents ::", troubledEvents.length);
      bandData.datasets.push({
        label: this.props.name + ' Troubled',
        fill: false,
        borderColor: '#F8B43B',
        backgroundColor: '#F8B43B',
        lineTension: 0.1,
        borderDash: [],
        borderDashOffset: 0.0,
        borderWidth: 3,
        borderJoinStyle: 'miter',
        pointBorderColor: '#00000',
        pointBackgroundColor: '#F8B43B',
        pointBorderWidth: 3,
        pointHoverRadius: 5,
        pointHoverBackgroundColor: '#F8B43B',
        pointHoverBorderColor: '#F8B43B',
        pointHoverBorderWidth: 2,
        pointRadius: 1,
        pointHitRadius: 10,
        data: troubledEvents,
      });
    }
    var timeFormatFn = (ts) => {
      //console.log(Moment(ts.format('YYYY-MM-DD HH:mm')))
      return Moment(ts.format('MMM-DD h:mm'));
    };

    var option = {
      legend: {
        display: false,
      },
      maintainAspectRatio: false,
      height: 150,
      scales: {
        xAxes: [xAxesOption],
        yAxes: [
          {
            scaleLabel: {
              display: false,
            },
            gridLines: {
              drawBorder: false,
            },
            type: 'linear',
            position: 'left',
            ticks: {
              min: 0,
            },
          },
        ],
      },
    };
    // console.log("xAxesOption")
    return (
      <div className={[classes.BodyRow, classes.BodyRow1].join(' ')}>
        <div className={classes.BodyTitle}>
          <b>{this.props.name}</b>
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <span
            style={{
              width: 10,
              marginRight: 5,
              height: 10,
              borderRadius: '50%',
              backgroundColor: 'green',
              display: 'inline-block',
            }}
          />{' '}
          <span style={{ fontSize: 10, marginRight: 10 }}> Successes</span>
          <span
            style={{
              width: 10,
              marginRight: 5,
              height: 10,
              borderRadius: '50%',
              backgroundColor: 'red',
              display: 'inline-block',
            }}
          />{' '}
          <span style={{ fontSize: 10 }}> Failures</span>
        </div>
        <div className={classes.BodyInfo}>
          <Line data={bandData} options={option} />
        </div>
      </div>
    );
  }
}
